export const uniqueArray = (array) => array.filter((item, index) => array.indexOf(item) === index)
